import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import HangLine from '../../../../assets/tree/hang-line.svg';
import StarsImg from '../../../../assets/tree/Little_Stars.svg';
import { myRoomViewModel } from '../my.room.viewmodel';
import { useAuth } from '../../../auth/Auth';
import { feedViewModel } from '../../feed/feed.view.model';
import { SHARE_CREATION_ROUTE_BANNER } from '../../../../constants/routes.constants';
import { useHistory } from 'react-router-dom';

const TreeCreations = ({ kidId, acceptedChallenges }) => {
  const [kidCreations, setKidCreations] = useState([]);
  const [feedList, setFeedList] = useState([]);
  const { fetchAPI } = useAuth();
  const history = useHistory();
  const [query, setQuery] = useState({
    limit: 6,
    has_more: true,
    trending: false,
  });
  const getCreationClassName = (index) => {
    switch (index) {
      case 0:
        return 'one';
      case 1:
        return 'two';
      case 2:
        return 'three';
      case 3:
        return 'four';
      case 4:
        return 'five';
      case 5:
        return 'six';
      default:
        return 'unknown'; // Default case for any index not covered
    }
  };

  const fetchCreations = () => {
    const queryParams = {
      dependent_id: kidId,
      for_challenges: false,
      limit: 6,
    };
    fetchAPI(myRoomViewModel.getCreations, queryParams, kidCreations)
      .then((data) => {
        setKidCreations(data?.creationList);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getFeed = () => {
    const previousFeedList = feedList;
    fetchAPI(feedViewModel.getFeed, query, previousFeedList)
      .then((data) => {
        setFeedList(data.feedList);
        setQuery(data.query);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onCreationClick = (creationId) => {
    const encoded = btoa(`{"id":${creationId}, "slug":"creation"}`);
    history.push({
      pathname: SHARE_CREATION_ROUTE_BANNER,
      search: `?encrypt=${encoded}`,
    });
  };

  useEffect(() => {
    if (kidId) {
      fetchCreations();
    } else {
      getFeed();
    }
  }, [kidId]);

  const creations = kidId ? kidCreations : feedList;

  return creations.map((creation, key) => {
    return (
      <Box className={`hanging-creation-wrapper ${getCreationClassName(key)}`}>
        <Box
          component="img"
          src={HangLine}
          alt="Hangline"
          sx={{
            transform: 'translate(-50%, 0)',
          }}
        />
        <Box
          className="hanging-img"
          component="img"
          src={
            creation?.media[0]?.s150_url
              ? creation?.media[0]?.s150_url
              : creation?.media[0]?.url
          }
          alt="Hangline"
          sx={{
            position: 'absolute',
            top: '67%',
            transform: 'translate(-50%, 0)',
            width: '35px',
            height: '35px',
            borderRadius: '10px',
            zIndex: 9,
            cursor: 'pointer',
          }}
          onClick={() => onCreationClick(creation?.creation_id || creation?.id)}
        />
        <Box
          component="img"
          src={StarsImg}
          className={`stars-img ${getCreationClassName(key)}`}
        />
      </Box>
    );
  });
};

export default TreeCreations;
